import { Col, Row, Skeleton } from 'ui';

type P = {
  cols: number;
};

const TodosWidgetLoadingState = ({ cols }: P) => (
  <Row className="todos-widget-loading-state">
    {[...Array.from({ length: cols }).keys()].map((todo) => (
      <Col className="todos-widget-loading-state__item" key={todo} span={24}>
        <Skeleton active paragraph={{ rows: 2 }} />
      </Col>
    ))}
  </Row>
);

export default TodosWidgetLoadingState;
